import InfoTooltip from "components/Popup/InfoTooltip";
import InfoIcon from "../../../../../images/info-icon.png";
import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import { selectExpense, updateExpense } from "../main.slice";
import { IExpense } from "Dashboard/scenes/HumanResources/domain/IExpense";
import { toast } from "react-toastify";

interface IProps {
  expensesCount: number;
  totalAmountPaid: number
}

const TableFooter = ({ expensesCount, totalAmountPaid }: IProps) => {

  const dispatch = useAppDispatch();
  const expenseItem = useSelector(selectExpense);

  const handleStatusChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newStatus = e.target.value;
    try {
      await dispatch(
        updateExpense({
          expenseId: expenseItem.expenseId,
          data: { status: newStatus },
        })
      );
      toast.success("Status je uspešno izmenjen.");
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  return (
    <>
      <div className="row">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div className="col">
          <div className="bg-item-border-light center">
            <span className="light">{expensesCount}</span>
          </div>
        </div>
        <div className="col">
          <div className="bg-item-border-light center">
            <span className="light">{totalAmountPaid} rsd</span>
          </div>
        </div>
        <div></div>
      </div>
      <hr />
      <div className="info">
        <InfoTooltip tooltip="Info" classesProp="icon" onClick={() => { }}>
          <img src={InfoIcon} alt="" />
        </InfoTooltip>

        <InfoTooltip tooltip={expenseItem?.title} classesProp="title">{expenseItem?.title}</InfoTooltip>

        <select className="status" value={expenseItem?.status} onChange={handleStatusChange}>
          <option value="ACTIVE">Aktivan</option>
          <option value="INACTIVE">Neaktivan</option>
        </select>
      </div>
    </>
  )
}

export default TableFooter
